import { IStudioCard } from '@/pages/home/pages/studio/type';

const METRIC_LIST: IStudioCard = {
  className: 'dbh-in-game-analytics-metrics',
  gap: 20,
  cardType: 'metric',
  headerTitleEn: "Key metrics",
  headerTitleCn: "核心指标",
  headerJumpUrl: "overview/daily",
  list: [{
    jumpUrl: '/monetization/salesOverview/revenue',
    haveJump: true,
    titleEn: "Lifetime Revenue After Refund & Tax",
    titleCn: "累计收入(剔除退款&税）",
    rainbowKey: "Pc Lifetime Revenue After Refund & Tax",
    explainEn: "",
    explainCn: "",
    preUnit: "$",
    icon: 'game',
    span: 8,
    cardType: 'metric',
    metricKey: 'accumulated_revenue',
    type: 'decimals',
    decimal: 2,
    isLeftCard: true,
  },
  {
    jumpUrl: '/monetization/salesOverview/revenue',
    haveJump: true,
    titleEn: "Lifetime Base Game Units After Refund",
    titleCn: "累计本体净销量",
    rainbowKey: "Pc Lifetime Base Game Units After Refund",
    explainEn: "",
    explainCn: "",
    icon: 'game',
    span: 8,
    cardType: 'metric',
    metricKey: 'accumulated_full_game_units',
    type: 'int',
    decimal: 0,
  },
  {
    jumpUrl: '/overview/daily',
    haveJump: true,
    titleEn: "DAU",
    titleCn: "日活跃",
    rainbowKey: "Pc DAU",
    explainEn: "Daily Active Users.Number of users who have logged in to the game during the statistical period (userid deduplicated).",
    explainCn: "统计周期内登录过游戏的用户数(userid数去重)。",
    icon: 'user-session',
    span: 8,
    cardType: 'metric',
    metricKey: 'active_users',
    type: "int",
    decimal: 0,
  }],
};

const WARFRAME_METRIC_LIST: IStudioCard = {
  className: 'dbh-in-game-analytics-metrics',
  gap: 20,
  cardType: 'metric',
  headerTitleEn: "Key metrics",
  headerTitleCn: "核心指标",
  headerJumpUrl: "overview/daily-v4",
  list: [
    {
      jumpUrl: '/overview/daily-v4',
      haveJump: true,
      titleEn: "New",
      titleCn: "新进用户",
      rainbowKey: "Pc New",
      explainEn: "New Register Users.Total number of newly-registered users in the statistical period (userid deduplicated).",
      explainCn: "统计周期内新注册用户数(userid数去重)。",
      icon: 'user-plus',
      span: 8,
      cardType: 'metric',
      metricKey: 'new_users',
      type: 'int',
      decimal: 0,
    },
    {
      jumpUrl: '/overview/daily-v4',
      haveJump: true,
      titleEn: "Revenue",
      titleCn: "净收入",
      rainbowKey: "Pc Revenue",
      explainEn: "The sales amount of all products (Base Game, DLC, Bundle, MTX) includes platform shares but excludes refunds, taxes, and retail revenue (e.g., Humble Bundle, Heybox).\\n Data source:Steam/Epic/XBOX/PlayStation platforms \\n Time zone:Steam sales data is in PST time zone,Epic/XBOX/PlayStation sales data is in UTC+0 time zone",
      explainCn: "所有产品（本体、DLC、捆绑包、MTX）在各平台的总销售额，包括平台分成，但不包括退款、税费和第三方零售收入（如 Humble Bundle、Heybox）\\n 数据来源:Steam/Epic/XBOX/PlayStation 平台 \\n 时区:Steam 数据采用PST时区，Epic/XBOX/PlayStation 数据采用 UTC+0 时区",
      preUnit: "$",
      icon: 'money',
      span: 8,
      cardType: 'metric',
      metricKey: 'mtx_revenue',
      type: 'decimals',
      decimal: 2,
      isLeftCard: true,
    },
    {
      jumpUrl: '/overview/daily-v4',
      haveJump: true,
      titleEn: "DAU",
      titleCn: "日活跃",
      rainbowKey: "Pc DAU",
      explainEn: "Daily Active Users.Number of users who have logged in to the game during the statistical period (userid deduplicated).",
      explainCn: "统计周期内登录过游戏的用户数(userid数去重)。",
      icon: 'user-session',
      span: 8,
      cardType: 'metric',
      metricKey: 'active_users',
      type: "int",
      decimal: 0,
    }],
};

const DL2_METRIC_LIST: IStudioCard = {
  className: 'dbh-in-game-analytics-metrics',
  gap: 20,
  cardType: 'metric',
  headerTitleEn: "Key metrics",
  headerTitleCn: "核心指标",
  headerJumpUrl: "overview/daily",
  list: [{
    jumpUrl: '/monetization/salesOverview/revenue',
    haveJump: true,
    titleEn: "Lifetime Net Revenue",
    titleCn: "总收入",
    rainbowKey: "Pc Lifetime Net Revenue",
    explainEn: "",
    explainCn: "",
    preUnit: "$",
    icon: 'game',
    span: 8,
    cardType: 'metric',
    metricKey: 'lifetime_net_revenue',
    type: 'decimals',
    decimal: 2,
    isLeftCard: true,
  },
  {
    jumpUrl: '/monetization/salesOverview/revenue',
    haveJump: true,
    titleEn: "Lifetime Base Game Units After Refund",
    titleCn: "累计本体净销量",
    rainbowKey: "Pc Lifetime Base Game Units After Refund",
    explainEn: "",
    explainCn: "",
    icon: 'game',
    span: 8,
    cardType: 'metric',
    metricKey: 'lifetime_net_units',
    type: 'int',
    decimal: 0,
  },
  {
    jumpUrl: '/overview/daily',
    haveJump: true,
    titleEn: "DAU",
    titleCn: "日活跃",
    rainbowKey: "Pc DAU",
    explainEn: "Daily Active Users.Number of users who have logged in to the game during the statistical period (userid deduplicated).",
    explainCn: "统计周期内登录过游戏的用户数(userid数去重)。",
    icon: 'user-session',
    span: 8,
    cardType: 'metric',
    metricKey: 'active_users',
    type: "int",
    decimal: 0,
  }],
};

const CARD_LIST: Array<IStudioCard> = [
  {
    className: 'dbh-in-game-analytics-sales',
    gap: 20,
    cardType: 'col',
    list: [{
      headerTitleEn: "Sales&Monetization",
      headerTitleCn: "销售&商业化",
      headerJumpUrl: "monetization/salesOverview/revenue",
      jumpUrl: 'monetization/salesOverview/revenue',
      titleEn: "Sales Analysis",
      titleCn: "销售分析",
      descEn: "Integrates sales data from multiple platforms and provides data insights.",
      descCn: "整合全平台的销售数据并提供销售数据洞察",
      icon: "salesAnalysis",
      span: 8,
      cardType: 'col',
      module_key: 'sales_analysis',
      header_module_key: 'sales_monetization',
    },
    {
      jumpUrl: 'monetization/salesOverview/breakdown',
      titleEn: "Bundle/DLC Sales",
      titleCn: "Bundle/DLC产品分析",
      descEn: "Provides Bundle/DLC product sales trend and sales ranking analysis.",
      descCn: "提供Bundle/DLC产品销售趋势和排行分析",
      icon: "bundleDlcSales",
      span: 8,
      cardType: 'col',
      module_key: 'bundle_dlc_sales'
    },
    {
      jumpUrl: 'looker/report/Refund%20Rate%20Monitor',
      titleEn: "Refund Analysis",
      titleCn: "退款分析",
      descEn: "Provide refund benchmark, monitor refund rate and gather refund reasons from feedback.",
      descCn: "提供退款率benchmark并监控退款异常，通过玩家反馈获取退款原因",
      icon: "refundAnalysis",
      span: 8,
      cardType: 'col',
      module_key: 'refund_analysis',
    }],
  },
  {
    className: 'dbh-in-game-analytics-wishlist',
    gap: 20,
    cardType: 'col',
    list: [{
      headerTitleEn: "Wishlist",
      headerTitleCn: "愿望清单",
      headerJumpUrl: "datalab/customDashboard/Steam%20Lifetime%20Wishlist",
      jumpUrl: 'datalab/customDashboard/Steam%20Lifetime%20Wishlist',
      titleEn: "Wishlist Analysis",
      titleCn: "愿望清单",
      descEn: "Forecast sales data and correlate market events with wishlist to optimize marketing strategies.",
      descCn: "分析预测销售数据，关联市场事件分析wishlist变化情况，优化市场策略",
      icon: "wishlistAnalysis",
      span: 8,
      cardType: 'col',
      header_module_key: 'wishlist',
      module_key: 'wishlist_analysis',
    },
    {
      headerTitleEn: "Event",
      headerTitleCn: "事件分析",
      headerJumpUrl: "eventAnalysis/eventAnalysis",
      jumpUrl: 'eventAnalysis/eventAnalysis',
      titleEn: "Event Analysis",
      titleCn: "事件分析",
      descEn: "Analyze the impact of different types of events on the game key metrics.",
      descCn: "分析不同类型的事件对游戏核心指标的影响",
      icon: "eventAnalysis",
      span: 8,
      cardType: 'col',
      header_module_key: 'event',
      module_key: 'event_analysis',
    },
    {
      jumpUrl: 'comparisonAnalysis/eventComparison',
      titleEn: "Event Comparison",
      titleCn: "事件对比",
      descEn: "Game version/season/in-game event/promotion comparison analysis.",
      descCn: "游戏版本/赛季/活动/促销事件对比分析",
      icon: "eventComparison",
      span: 8,
      cardType: 'col',
      module_key: 'event_comparison',
    }]
  },
  {
    className: 'dbh-in-game-analytics-engagement',
    gap: 20,
    cardType: 'row',
    list: [{
      headerTitleEn: "Engagement",
      headerTitleCn: "活跃数据",
      headerJumpUrl: "engagement/register",
      jumpUrl: 'engagement/register',
      titleEn: "New",
      titleCn: "新进",
      descEn: "Analyze the new users of the game by country/platform",
      descCn: "分国家/平台分析游戏新进用户",
      icon: "new",
      span: 8,
      cardType: 'row',
      header_module_key: 'engagement',
      module_key: 'new',
    },
    {
      jumpUrl: 'engagement/active',
      titleEn: "Active",
      titleCn: "活跃",
      descEn: "Analyze the active users of the game by country/platform",
      descCn: "分国家/平台分析游戏活跃用户",
      icon: "active",
      span: 8,
      cardType: 'row',
      module_key: 'active',
    },
    {
      jumpUrl: 'retention/index',
      titleEn: "Retention",
      titleCn: "留存",
      descEn: "Track the retention of new users for 1-90 days",
      descCn: "新进用户1-90天留存追踪",
      icon: "retention",
      span: 8,
      cardType: 'row',
      module_key: 'retention',
    }]
  },
  {
    className: 'dbh-in-game-analytics-gaas',
    gap: 20,
    cardType: 'row',
    list: [{
      headerTitleEn: "Crash&Stability",
      headerTitleCn: "崩溃&稳定性",
      headerJumpUrl: "looker/report/Crash%20-%20Session",
      jumpUrl: 'looker/report/Crash%20-%20Session',
      titleEn: "Crash",
      titleCn: "Crash",
      descEn: "Analyze game crash rates by user/device/session",
      descCn: "按用户/设备/会话分析游戏crash率",
      icon: "crash",
      span: 8,
      cardType: 'row',
      module_key: 'crash',
      header_module_key: 'crash_stability'
    },
    {
      jumpUrl: 'looker/report/FPS',
      titleEn: "FPS",
      titleCn: "FPS",
      descEn: "Analyze the FPS of the game by country/platform/version/device level",
      descCn: "分国家/平台/版本/机型分析游戏FPS情况，帮助提升游戏稳定性",
      icon: "fps",
      span: 8,
      cardType: 'row',
      module_key: 'fps',
    },
    {
      jumpUrl: 'looker/report/Latency%20-%20Ping',
      titleEn: "Latency",
      titleCn: "网络延迟",
      descEn: "Analyze the latency of the game by country",
      descCn: "分国家分析游戏网络延迟情况，快速发现服务器异常，优化玩家体验",
      icon: "latency",
      span: 8,
      cardType: 'row',
      module_key: 'latency',
    }]
  }
];

// url 替换
function replaceCardListUrls(
  cardList: Array<IStudioCard>, 
  targetClassName: string, 
  newUrls: Array<{ headerJumpUrl?: string|undefined; jumpUrl: string|undefined; }>
): Array<IStudioCard> {
  return cardList.map(card => {
    if (card.className === targetClassName) {
      // 替换目标 className 的 list 内容
      return {
        ...card,
        list: card?.list?.map((item, index) => ({
          ...item,
          ...(newUrls[index]?.headerJumpUrl && { headerJumpUrl: newUrls[index].headerJumpUrl }), // 有 headerJumpUrl 时才替换
          jumpUrl: newUrls[index]?.jumpUrl || item.jumpUrl, // 始终替换 jumpUrl
        })),
      };
    }
    return card; // 其他的保持不变
  });
}

export const ANALYTICS_CONFIG: Array<IStudioCard> = [
  METRIC_LIST,
  ...CARD_LIST,
];

export const DL2_ANALYTICS_CONFIG: Array<IStudioCard> = [
  DL2_METRIC_LIST,
  ...CARD_LIST,
];

export const WARFRAME_ANALYTICS_CONFIG: Array<IStudioCard> = [
  WARFRAME_METRIC_LIST,
  ...CARD_LIST,
];

// 替换目标数据
const NEW_REBIRTH_CARD_LIST = replaceCardListUrls(CARD_LIST, 'dbh-in-game-analytics-gaas', [
  { headerJumpUrl: 'datalab/customDashboard/Crash', jumpUrl: 'datalab/customDashboard/Crash' },
  { jumpUrl: 'datalab/customDashboard/FPS' },
  { jumpUrl: 'looker/report/Latency%20%20Ping' },
]);
export const REBIRTH_ANALYTICS_CONFIG: Array<IStudioCard> = [
  METRIC_LIST,
  ...NEW_REBIRTH_CARD_LIST,
];
// 替换目标数据
const NEW_DUNE_CARD_LIST = replaceCardListUrls(CARD_LIST, 'dbh-in-game-analytics-gaas', [
  { headerJumpUrl: 'datalab/customDashboard/Overall%20Crash%20Analysis', jumpUrl: 'datalab/customDashboard/Overall%20Crash%20Analysis' },
  { jumpUrl: "undefined" },
  { jumpUrl: "undefined" },
]);
export const DUNE_ANALYTICS_CONFIG: Array<IStudioCard> = [
  METRIC_LIST,
  ...NEW_DUNE_CARD_LIST,
];

export const DEFAULT_PLATFORM_DISABLE = ["Steam", "Xbox", "Epic", "PlayStation", "Heybox"];

export const SHOW_PAGE_CARD_LIST: {
  [key: string]: Array<IStudioCard>;
} = {
  dl2: DL2_ANALYTICS_CONFIG,
  warframe_all: WARFRAME_ANALYTICS_CONFIG,
  pc_dev_demo: WARFRAME_ANALYTICS_CONFIG,
  rebirth: REBIRTH_ANALYTICS_CONFIG,
  dune: DUNE_ANALYTICS_CONFIG
};
